import { useState } from 'react';
import { useGetBetHistoryQuery } from '@/store/api/betApi';
import { formatDateTime, isGuestUser } from '@/utils';
import { useParams } from 'react-router-dom';

const FILTERS = ['ALL', 'MATCHED', 'UNMATCHED', 'FANCY'] as const;
type Filter = (typeof FILTERS)[number];

const MyBets = () => {
  const isGuest = isGuestUser();
  const { eventId } = useParams();
  const { data } = useGetBetHistoryQuery(
    {
      betTime: 'CURRENT',
      eventId: Number(eventId),
      limit: 10,
    },
    { skip: isGuest }
  );

  const [activeFilter, setActiveFilter] = useState<Filter>('ALL');

  const bets = data?.bets ?? [];

  const filteredBets =
     activeFilter === 'FANCY'
        ? bets.filter((item) => item?.marketType === 'FANCY')
        : bets;

  return (
    <>
      <div className="bg-secondary-dark text-white h-6 font-semibold mt-1"></div>
      <div className="bg-primary ">
        {/* Filters / Tabs */}
        <div className="my-1">
          <div className="flex items-center   overflow-hidden text-sm border border-black">
            {FILTERS.map((f) => (
              <button
                key={f}
                onClick={() => setActiveFilter(f)}
                className={`px-3 py-1 flex-1 text-center font-semibold text-white hover:text-white transition-colors border-x border-black  ${
                  activeFilter === f ? 'bg-secondary-dark text-white' : ''
                }`}
              >
                {f}
                {f === 'ALL' && ` (${bets.length})`}
              </button>
            ))}
          </div>
        </div>

        <table
          className="w-full text-xs font-semibold text-white border-separate"
          style={{ borderSpacing: 0 }}
        >
          {/* Table Head */}
          <thead className=" text-white">
            <tr>
              <th className="text-left px-2 py-1 font-semibold border border-white/20">
                SELECTION
              </th>
              <th className="text-right px-2 py-1 font-semibold border border-white/20">ODDS</th>
              <th className="text-right px-2 py-1 font-semibold border border-white/20">STAKE</th>
              <th className="text-right px-2 py-1 font-semibold border border-white/20">
                DATE/TIME
              </th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {filteredBets.map((item, idx) => (
              <tr
                key={item?.id ?? idx}
                className={`text-black border border-white/10   ${item?.betOn?.toUpperCase() == 'BACK' ? 'bg-back' : 'bg-lay'}`}
              >
                <td className="px-2 py-1 border border-white/10">
                  <div className=" text-black px-2 py-0.5 rounded-sm truncate">
                    {item?.selection ?? '-'}
                  </div>
                </td>
                <td className="px-2 py-0.5 text-right border border-white/10">
                  {item?.odds ?? '-'}
                </td>
                <td className="px-2 py-0.5 text-right border border-white/10">
                  {item?.amount ?? '-'}
                </td>
                <td className="px-2 py-0.5 text-right border border-white/10">
                  {formatDateTime(item?.placedAt ?? '-')}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* <Link to={'/user/bet-history'} className="block px-1 py-2 font-bold underline text-white">
          See More
        </Link> */}
      </div>
    </>
  );
};

export default MyBets;
